import api from "../axios";

/**
 * API for managing SignalR tokens
 */
export const signalRTokenApi = {
  /**
   * Exchange JWT for compact SignalR token
   */
  async exchangeForSignalRToken(): Promise<{ signalRToken: string }> {
    const response = await api.post("/api/SignalRToken/exchange");
    return response.data;
  },
};
